export default "__VITE_ASSET__B_zpSJ9X__"